import { HttpClient } from '@wix/fe-essentials/http-client';
export var createHttpClient = function (_a) {
    var _b = _a.isSSR, isSSR = _b === void 0 ? false : _b, getAppToken = _a.getAppToken, errorHandler = _a.errorHandler;
    return new HttpClient({
        isSSR: isSSR,
        getAppToken: getAppToken,
        errorHandler: errorHandler,
    });
};
//# sourceMappingURL=httpClientProp.js.map